import type { FieldRendererProps } from '../../config/types';
import { Input } from '@/components/ui/Input';

export function NumberFieldRenderer({ field, value, onChange, onBlur, error }: FieldRendererProps) {
  const { min, max } = field.resolvedValidations;
  return (
    <Input
      type="number"
      id={field.id}
      value={value != null && value !== '' ? String(value) : ''}
      onChange={(e) => {
        const raw = e.target.value;
        onChange(raw === '' ? '' : raw);
      }}
      onBlur={onBlur}
      placeholder={field.placeholder}
      disabled={field.isDisabled}
      min={min}
      max={max}
      aria-invalid={!!error}
      className="font-mono tabular-nums"
    />
  );
}
